import { useEffect, useState } from "react";
import { config } from "../config";
import { createApiClient } from "../api/client";

export type HealthStatus = "unknown" | "online" | "offline";

export function useApiHealth(pollMs = 15000): HealthStatus {
  const [status, setStatus] = useState<HealthStatus>("unknown");

  useEffect(() => {
    const client = createApiClient(config.apiBaseUrl, async () => null);
    let active = true;

    async function check() {
      try {
        await client.getLiveness();
        if (active) setStatus("online");
      } catch {
        if (active) setStatus("offline");
      }
    }

    check();
    const id = setInterval(check, pollMs);
    return () => {
      active = false;
      clearInterval(id);
    };
  }, [pollMs]);

  return status;
}
